<template>
    <main class="l5g75cki">
        <!-- container -->
        <div
            class="l5g76h3r"
            :style="{
                width: local.value.containerWidth,
            }"
        >
            <router-view
                class="l5hzimhh"
                :dbNameCn="dbNameCn"
            ></router-view>

            <!-- 百度广告 -->
            <div class="baiduads">
                <BaiduAds id="u6980841"/>
            </div>

            <!-- 功能按钮 -->
            <!-- <div class="l5geaniy">
                <i
                    v-if="!isMobile"
                    class="el-icon-full-screen"
                    @click="handleToggle"
                ></i>
            </div> -->
        </div>
    </main>
</template>

<script>
import Vue from "vue";
import ViewsDetailComponentsToolsBlock from "./Detail/components/ToolsBlock.vue";
import ViewsDetailComponentsTabs from "./Detail/components/Tabs.vue";
import dbNameMap from "@/data/dbNameMap";
Vue.component(
    "ViewsDetailComponentsToolsBlock",
    ViewsDetailComponentsToolsBlock
);
Vue.component("ViewsDetailComponentsTabs", ViewsDetailComponentsTabs);

export default {
    name: "ViewsDetail",
    data() {
        return {
            containerStyle: {
                width: "1200px",
            },
        };
    },
    computed: {
        dbName() {
            return this.$route.params.dbName;
        },
        dbNameCn() {
            return dbNameMap[this.dbName.toLowerCase()];
        },
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/index.less";
.l5g75cki {
    .bsbb;
    min-height: calc(100vh - 60px);
    background: #efefef;
    padding: 10px;
}
.l5g76h3r {
    .ma;
}
// .l5geaniy {
//     .pa;
//     .df;
//     top: 0;
//     right: 0;
//     i {
//         .cp;
//         .fwb;
//         .fs12;
//         .c-theme;
//         padding: 4px;
//     }
// }
// children
.l5hzimhh {
    .fs14;
    color: #333;
}
.l5iziti7 {
    .fwb;
    .fs16;
    .df;
    margin: 0;
    padding: 20px 0 14px 0;
}
.l5izj71j {
    font-weight: normal;
}
</style>
<style lang="less">
@import (reference) "@/assets/less/index.less";
.baiduads{
    display: flex;
    justify-content: center;
    padding: 20px 0;
}
// 移动端
@media screen and (max-width: 750px) {
    .l5g75cki {
        padding: 10px;
    }
}
</style>
<style lang="less">
@import (reference) "@/assets/less/index.less";
// print style
@media print {
    // @page {
    //     size: 18in 23.6in;
    // }
    #app {
        header,
        aside,
        footer {
            .dn;
        }
    }
}
</style>
